import { ChevronDown, KeyRound, LogOut } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { useAuth } from '@/features/auth/hooks/useAuth';
import { initials } from '@/shared/lib/format';

import { BrandMark } from './BrandMark';

/**
 * The account menu, and nothing else yet.
 *
 * kdoshr-app also carries a notification bell and a site selector here. Both
 * are its own domain; this is the frame they would hang off.
 */
export function Topbar() {
  const { t } = useTranslation('auth');
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="bg-surface border-border flex h-14 shrink-0 items-center gap-3 border-b px-4 print:hidden">
      <BrandMark className="md:hidden" />

      {/* <SiteSelector /> just for now*/}

      <div className="ml-auto flex items-center gap-3">
        {user && (
          <div className="relative">
            <button
              type="button"
              onClick={() => setMenuOpen((open) => !open)}
              aria-haspopup="menu"
              aria-expanded={menuOpen}
              aria-label={t('user.myAccount')}
              className="hover:bg-surface-sunken flex items-center gap-2 rounded-(--radius-control) p-1 pr-2 transition-colors"
            >
              <span
                aria-hidden
                className="bg-brand-900 flex size-8 items-center justify-center rounded-full text-xs font-semibold text-white"
              >
                {initials(user.full_name)}
              </span>
              <span className="text-ink hidden text-sm sm:inline">{user.full_name}</span>
              <ChevronDown className="text-ink-subtle size-3.5" aria-hidden />
            </button>

            {menuOpen && (
              <>
                <div
                  className="fixed inset-0 z-40"
                  onClick={() => setMenuOpen(false)}
                  aria-hidden="true"
                />
                <div
                  role="menu"
                  className="bg-surface border-border absolute right-0 z-50 mt-2 w-56 rounded-(--radius-card) border p-1 shadow-(--shadow-overlay)"
                >
                  <button
                    type="button"
                    role="menuitem"
                    onClick={() => {
                      setMenuOpen(false);
                      void navigate('/cambiar-contrasena');
                    }}
                    className="text-ink hover:bg-surface-sunken flex w-full items-center gap-2 rounded-(--radius-control) px-3 py-2 text-sm"
                  >
                    <KeyRound className="size-4" aria-hidden />
                    {t('user.changePassword')}
                  </button>
                  <button
                    type="button"
                    role="menuitem"
                    onClick={() => {
                      setMenuOpen(false);
                      void logout();
                    }}
                    className="text-ink hover:bg-surface-sunken flex w-full items-center gap-2 rounded-(--radius-control) px-3 py-2 text-sm"
                  >
                    <LogOut className="size-4" aria-hidden />
                    {t('logout.action')}
                  </button>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </header>
  );
}
